"use client";

import LocaleSwitcher from "@/components/Footer/LocaleSwitcher";
import { FooterLocaleSwitcherFeature } from "@/components/LocaleSwitcher/FooterLocaleSwitcherFeature";
import { FooterLink } from "@/types/Footer";
import { CTA } from "@/types";
import OtBannerLink from "../OtBannerLink";

type Props = {
  links?: FooterLink[];
};

export default function SecondaryLinks({ links }: Props) {
  if (!links) return null;

  return (
    <div className="flex flex-wrap justify-between">
      {links.map((section) => (
        <div key={section.id} className="mr-12 mb-6 grow">
          {getSecondaryLinks(section)}
        </div>
      ))}
      <FooterLocaleSwitcherFeature>
        <div className="mb-6 flex">
          <LocaleSwitcher />
        </div>
      </FooterLocaleSwitcherFeature>
    </div>
  );
}

const getSecondaryLinks = (linkSection: FooterLink) => {
  return (
    <>
      <span className="text-base text-left pb-6 mt-0 font-bold">
        {linkSection.label}
      </span>
      <ul className="my-6 list-none">
        {linkSection.childItems.nodes.map((link: CTA) => (
          <li key={link.label} className="mb-2 hover:underline text-base">
            {link.label === "Your Privacy Choices" ? (
              <OtBannerLink
                href={link.url}
                text={link.label}
                className="text-white hover:text-white"
              />
            ) : (
              <a className="text-white hover:text-white" href={link.url}>
                {link.label}
              </a>
            )}
          </li>
        ))}
      </ul>
    </>
  );
};
